import "../../styles/templates/_page.what-theyre-saying.scss";
import Press from '../modules/Press';
import Ambassadors from '../modules/Ambassadors';
import WhatTheyreSayingSliders from '../modules/WhatTheyreSayingSliders';
class PageWhatTheyreSaying {
    constructor() {
        this.init();
    }
    init() {
        console.log('UNTUCKit : Template : PageWhatTheyreSaying', this);
        WhatTheyreSayingSliders.init();
        Press.init();
        Ambassadors.init();
    }
}
$(() => {
    new PageWhatTheyreSaying();
});
